import { createAction } from '@reduxjs/toolkit'
import { FootnotePayload } from 'types/storeTypes'

export const showFootnote = createAction<FootnotePayload>(
  '@FOOTNOTE/SHOW_FOOTNOTE'
)

export const hideFootnote = createAction('@FOOTNOTE/HIDE_FOOTNOTE')
